import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const DuplicateCampaignBriefFormValidationRules = yupResolver(
  yup.object({
    name: yup
      .string()
      .required("Campaign Brief Name is required.")
      .max(256, "Campaign Brief Name must be under 256 characters."),
  })
);
